import * as _ from 'lodash';
import * as moment from 'moment';

import { getFieldByMap, getItemProperty } from 'utils/utils';
import { segmentsData } from '../../product-details/segments-data-stub';
import { Config } from '../config/env.config';
import { SideNavButtonModel } from 'shared/status-sidenav/status-sidenav/side-nav.model';
import { packageTypeLookup } from './product-lookups';


export const getHeaderDescription = (itemDetail: any): string => {
  if (!itemDetail) { return ''; }
  const field: any = getFieldByMap('des', segmentsData.descriptions);
  const path = field ? `${field.item_name}.EN` : '';
  return getItemProperty(field, path, itemDetail);
};

export const getUpdatedDate = (itemDetail: any): string => {
  if (!itemDetail) { return ''; }
  return moment(itemDetail.updated_at).format('MMMM Do, YYYY');
};

export const getLastPublishedDate = (itemDetail: any): string => {
  if (!_.has(itemDetail, 'last_published_at') || !itemDetail.last_published_at) { return ''; }
  return moment(itemDetail.last_published_at).format('MMMM Do, YYYY');
};

export const getProductImageUrl = (itemDetail: any): string => {
  if (!itemDetail) { return Config.DEFAULT_PRODUCT_IMAGE; }
  if (itemDetail.itemId) {
    return `${Config.BACKEND}parts/assets/item/${itemDetail.itemId}/300?noCache=${Date.now()}`;
  } else {
    return Config.DEFAULT_PRODUCT_IMAGE;
  }
};


export const populateSideNavValues = (status: number, isPublish: boolean = false): any => {
  let sideNavStatus: string;
  const sideNavTopButton = new SideNavButtonModel(),
      sideNavBottomButton = new SideNavButtonModel();

  if (status === 0) {
    sideNavStatus = 'Draft';
    sideNavTopButton.show = false;

    sideNavBottomButton.text = 'Review';
    sideNavBottomButton.show = true;
    sideNavBottomButton.value = 1;
    sideNavBottomButton.hoverClass = 'hover-gold';
  } else if (status === 1) {
    sideNavStatus = 'Review';

    sideNavTopButton.text = 'Draft';
    sideNavTopButton.show = true;
    sideNavTopButton.value = 0;
    sideNavTopButton.hoverClass = 'hover-red';

    sideNavBottomButton.text = 'Approve';
    sideNavBottomButton.show = true;
    sideNavBottomButton.value = 2;
    sideNavBottomButton.hoverClass = 'hover-green';
  } else if (status === 2) {
    sideNavStatus = 'Approved';

    sideNavTopButton.text = 'Draft';
    sideNavTopButton.show = true;
    sideNavTopButton.value = 0;
    sideNavTopButton.hoverClass = 'hover-red';

    sideNavBottomButton.text = 'Publish';
    sideNavBottomButton.show = true;
    sideNavBottomButton.value = 8;
    sideNavBottomButton.hoverClass = 'hover-cadetblue';
  } else if (status === 3) {
    sideNavStatus = 'Archived';
    sideNavTopButton.show = false;
    sideNavBottomButton.show = false;
  } else if (status === 4) {
    sideNavStatus = 'Import Review';

    sideNavTopButton.show = false;

    sideNavBottomButton.text = 'Import';
    sideNavBottomButton.show = true;
    sideNavBottomButton.value = 5;
    sideNavBottomButton.hoverClass = 'hover-gold';
  } else if (status === 5) {
    sideNavStatus = 'Imported';
    sideNavTopButton.show = false;
    sideNavBottomButton.show = false;
  } else if (status === 6) {
    sideNavStatus = 'Exported';
    sideNavTopButton.show = false;
    sideNavBottomButton.show = false;
  } else if (status === 8) {
    sideNavStatus = 'Published';
    sideNavTopButton.show = false;
    if (isPublish) {
      sideNavBottomButton.text = 'Unpublish';
      sideNavBottomButton.show = true;
      sideNavBottomButton.value = 10;
      sideNavBottomButton.hoverClass = 'hover-red';
    }
  } else if (status === 10 && isPublish) {
    sideNavStatus = 'Unpublished';
    sideNavTopButton.show = false;
    sideNavBottomButton.text = 'Approve';
    sideNavBottomButton.show = true;
    sideNavBottomButton.value = 2;
    sideNavBottomButton.hoverClass = 'hover-green';
  } else {
    sideNavTopButton.show = false;
    sideNavBottomButton.show = false;
  }
  return {sideNavStatus, sideNavTopButton, sideNavBottomButton};
};

const getPackageUomTitle = (uomKey: string) => {
  const packageTypeOption = _.find(packageTypeLookup, {option: uomKey});
  return packageTypeOption ? packageTypeOption.title : null;
};

export const convertPackagesDataToArray = (packagesData: any): any[] => {
  /*
    convert from {
      EA: Obj,
    } to [{
      packageUom: 'EA',
      packageUomTitle: 'Smallest pack (consumer level)',
      ...Obj,
    }]
  */
  if (packagesData) {
    // always in the same order
    return _.map(packageTypeLookup, (option: any) => {
      const data = packagesData[option.option];
      if (!data || (!data[0] && data.dimensions)) {
        return {
          packageUom: option.option,
          packageUomTitle: getPackageUomTitle(option.option),
          [option.option]: data ? data : {},
        };
      }
      let i = 0;
      const packageArray = [];
      while (data[i]) {
        packageArray.push({
          packageUom: option.option,
          packageUomTitle: getPackageUomTitle(option.option),
          [option.option]: data[i],
        });
        i++;
      }
      return packageArray;
    });
  }
  return [];
};

export const getPackagesSegmentDataForType = (type: string, segmentData: any) => {
  return _.filter(segmentData, (segmentFieldItem: any) => {
    // if item_name starts with this type code
    return segmentFieldItem.item_name.indexOf(`${type}.`) === 0;
  });
};

export const convertPackagesScoreDataToArray = (scoreData: any) => {
  const packagesScoreDataArray = [];

  // find just packages validation
  const packagesScoreData = _.pickBy(scoreData, (value: any, key: any) => {
    return key.indexOf('packages.') === 0;
  });

  // create an array grouped by packages UOM (types)
  _.forEach(packageTypeLookup, (option: any) => {
    const packagesByType = _.pickBy(packagesScoreData, (value: any, key: any) => {
      return key.indexOf(`packages.${option.option}`) === 0;
    });

    packagesScoreDataArray.push(packagesByType);
  });

  return packagesScoreDataArray;
};

export const getExtInfoScoreData = (scoreData: any) => {
  const extInfoScoreData = _.pickBy(scoreData, (value: any, key: any) => {
    return key.indexOf('extendedInformation.') === 0;
  });

  const extInfoScoreDataReduced = {};
  // @ts-ignore
    _.mapKeys(extInfoScoreData, (value: any, key: string) => {
    extInfoScoreDataReduced[(`${key}`).replace('extendedInformation.', '')] = value;
  });
  return extInfoScoreDataReduced;
};

export const getPackageScoreItemPath = (index: number|string, item: any) => {
  return `[${index}]["packages.${item.item_name}"]`;
};

export const getAvailableSegmentScoreTypes = (scoreData: any) => {
  const segmentScoreTypes = [];
  _.forEach(packageTypeLookup, (type: any) => {
    if (_.some(_.keys(scoreData), (key: string) => {
      return key.indexOf(`packages.${type.option}.`) === 0;
    })) {
      segmentScoreTypes.push(type.option);
    }
  });
  return segmentScoreTypes;
};
